module.exports = __webpack_public_path__ + "04_glasses_red.acb66fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer4/04_glasses_red.png
// module id = c+EU
// module chunks = 0